import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const DotsIcon = ({ width = 27, height = 28, strokeColor = "var(--blue)" }: IIconProps) => {
	return (
		<svg width={width} height={height} viewBox="0 0 23 6" fill="none">
			<circle r="2.5" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.5 3)" fill="#C4C4C4" />
			<circle r="2.5" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 11.5 3)" fill="#C4C4C4" />
			<circle r="2.5" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.5 3)" fill="#C4C4C4" />
		</svg>
	)
}

export default DotsIcon
